import getCategories from "utils/select_options/getCategories";
import getProducers from "utils/select_options/getProducers";
import getBrands from "utils/select_options/getBrands";
import { product_status_search_options } from "utils/select_options/product_status_options";

export const sort = [
  {
    label: "",
    name: "image",
    style: { width: 70 },
    sortable: false,
  },
  {
    label: "SKU",
    name: "sku",
    style: { width: 150 },
  },
  { label: "Nazwa", name: "name", style: { width: 250 } },
  { label: "Status", name: "status", style: { width: 150 } },
  {
    label: "Kategoria",
    name: "root_taxon_name",
    sortable: false,
    style: { width: 150 },
  },
  {
    label: "Producent",
    name: "producer_name",
    sortable: false,
    style: { width: 150 },
  },
  {
    label: "Marka",
    name: "brand_name",
    sortable: false,
    style: { width: 150 },
  },
  {
    label: "Kanały",
    name: "channel_products",
    sortable: false,
  },
];

export const filters = [
  {
    type: "input",
    name: "name_or_sku_or_product_group_sku",
    sort_id: "sku",
    search_type: "matches",
  },
  {
    type: "input",
    name: "name",
    sort_id: "name",
    search_type: "matches",
  },
  {
    type: "select",
    name: "status",
    sort_id: "status",
    search_type: "in",
    options: product_status_search_options,
  },
  {
    type: "async_select",
    name: "producer_name",
    sort_id: "producer_name",
    search_type: "in",
    getData: getProducers,
  },
  {
    type: "async_select",
    name: "brand_name",
    sort_id: "brand_name",
    search_type: "in",
    getData: getBrands,
  },
  {
    type: "async_select",
    name: "root_taxon_name",
    sort_id: "root_taxon_name",
    search_type: "in",
    getData: getCategories,
  },
];
